(function () {
  function alignCols(wrapper) {
    var cols = Array.prototype.slice.call(wrapper.querySelectorAll('.chart-col'));
    if (cols.length < 2) return;

    cols.forEach(function (col) {
      Array.prototype.slice.call(col.children).forEach(function (child) {
        child.style.height = '';
      });
    });

    var maxLen = Math.max.apply(null, cols.map(function (col) {
      return col.children.length;
    }));

    for (var i = 0; i < maxLen; i++) {
      (function (idx) {
        var maxH = Math.max.apply(null, cols.map(function (col) {
          return col.children[idx] ? col.children[idx].offsetHeight : 0;
        }));
        cols.forEach(function (col) {
          if (col.children[idx]) {
            col.children[idx].style.height = maxH + 'px';
          }
        });
      })(i);
    }
  }

  function alignAll() {
    document.querySelectorAll('[data-cc-cols]').forEach(function (wrapper) {
      alignCols(wrapper);
    });
  }

  window.addEventListener('load', alignAll);
  window.addEventListener('resize', alignAll);
  document.addEventListener('shopify:section:load', alignAll);
})();
